import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CommandProgressEffects } from './command-progress.effects';
import { commandProgressFeatureKey, commandProgressReducer } from './command-progress.reducer';

export const provideCommandProgressStore = () => [
  provideState(commandProgressFeatureKey, commandProgressReducer),
  provideEffects([CommandProgressEffects]),
];
